// extracted by mini-css-extract-plugin
export var optionGrid = "_7v-7";
export var optionList = "_7v-6";
export var questionsBlock = "_7v-9";
export var spacer = "_7v-5";
export var stepCenteredContent = "_7v-3";
export var stepInner = "_7v-0";
export var stepInnerFullWidth = "_7v-1";
export var stepInnerLockScroll = "_7v-2";
export var stepTransitionFrame = "_7v-4";
export var welcomeBlock = "_7v-8";